// This file will help debug environment variables

// Helper function to safely check if environment variables exist
function safeEnvCheck(obj: any, path: string): { exists: boolean, value: string | null } {
  try {
    // Split the path into parts (e.g., "import.meta.env.VITE_SUPABASE_URL" -> ["import", "meta", "env", "VITE_SUPABASE_URL"])
    const parts = path.split('.');
    let current = obj;
    
    // Navigate through the object path
    for (const part of parts) {
      if (current === undefined || current === null) {
        return { exists: false, value: null };
      }
      current = current[part];
    }
    
    return { 
      exists: current !== undefined && current !== null, 
      value: typeof current === 'string' ? current : JSON.stringify(current)
    };
  } catch (e) {
    return { exists: false, value: null };
  }
}

// Log information about the environment
export function logEnvironmentInfo() {
  console.log('===== ENVIRONMENT DEBUG INFO =====');
  console.log('Mode:', import.meta.env.MODE);
  console.log('DEV:', import.meta.env.DEV);
  console.log('PROD:', import.meta.env.PROD);
  
  // Check standard Vite env vars
  console.log('VITE_SUPABASE_URL:', safeEnvCheck(import.meta.env, 'VITE_SUPABASE_URL').value || 'NOT SET');
  console.log('VITE_SUPABASE_ANON_KEY:', safeEnvCheck(import.meta.env, 'VITE_SUPABASE_ANON_KEY').value ? '[SET - HIDDEN]' : 'NOT SET');
  
  // Check Netlify vars
  console.log('SUPABASE_DATABASE_URL:', safeEnvCheck(import.meta.env, 'SUPABASE_DATABASE_URL').value || 'NOT SET');
  console.log('SUPABASE_ANON_KEY:', safeEnvCheck(import.meta.env, 'SUPABASE_ANON_KEY').value ? '[SET - HIDDEN]' : 'NOT SET');
  
  // Log all env variables for debugging (just keys, not values for security)
  console.log('All available env variable keys:');
  Object.keys(import.meta.env).forEach(key => {
    console.log(`- ${key}`);
  });
  
  console.log('================================');
}

// Auto-execute in development mode
if (import.meta.env.DEV) {
  logEnvironmentInfo();
} 